(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/drawselector/assets/javascripts/views/drawselector.js') >= 0) return;  svs.modules.push('/components/sport/drawselector/assets/javascripts/views/drawselector.js'); 
'use strict';

var _svs$sport$drawselect = svs.sport.drawselector,
    views = _svs$sport$drawselect.views,
    collections = _svs$sport$drawselect.collections;
var Drawselector = Backbone.Marionette.View.extend({
  regions: {
    headerRegion: '#drawselector-header',
    listRegion: '#drawselector-list'
  },
  childViewEvents: {
    'show:menu': 'toggleMenu',
    changeRound: 'changeRound'
  },
  template: function template(data) {
    return svs.sport.drawselector.templates.drawselector(data);
  },
  initialize: function initialize(options) {
    svs.sport.drawselector.collections.drawselectorCollection = new collections.DrawselectorList();
    svs.sport.drawselector.collections.drawselectorCollection.setData(options.draws, options.currentDraw);
  },
  onRender: function onRender() {
    var model = svs.sport.drawselector.collections.drawselectorCollection.getCurrentDraw();
    model.set('disableSlideDown', this.options.draws.length === 1);
    this.showChildView('headerRegion', new views.DrawselectorHeader({
      model: model,
      branding: this.options.branding
    }));
  },
  toggleMenu: function toggleMenu(shouldOpenMenu) {
    var self = this,
        listRegion = this.getRegion('listRegion');

    if (shouldOpenMenu) {
      if (!listRegion.hasView()) {
        var list = new views.DrawselectorList({
          collection: svs.sport.drawselector.collections.drawselectorCollection
        });
        list.on('attach', function () {
          listRegion.$el.slideDown('fast', function () {
            if (self.options.swiperUpdateFunction) {
              self.options.swiperUpdateFunction();
            }
          });
        });
        this.$('#drawselector-list').hide();
        this.showChildView('listRegion', list);
      } else {
        listRegion.$el.slideDown('fast', function () {
          if (self.options.swiperUpdateFunction) {
            self.options.swiperUpdateFunction();
          }
        });
      }
    } else {
      listRegion.$el.slideUp('fast', function () {
        if (self.options.swiperUpdateFunction) {
          self.options.swiperUpdateFunction();
        }
      });
    }
  },
  changeRound: function changeRound(drawNumber) {
    this.options.callback(drawNumber);
  }
});
setGlobal('svs.sport.drawselector.views.Drawselector', Drawselector);
 })(window);